'use strict';

/**
 * @name
 * dedupeLogs
 * @private
 * @description
 * Determines which logs are unique based on message content, line number,
 * column number, and url.
 * @param {array} logs
 * @returns {array}
 */

function dedupeLogs(logs) {
    const logsObj = logs.reduce((memo, log) => {
        const key = `${JSON.stringify(log.message)}, ${log.lineNumber}, ${log.columnNumber}, ${log.url}`;
        if (!memo[key]) {
            memo[key] = log;
        }
        return memo;
    }, {});

    return Object.keys(logsObj).map((key) => {
        return logsObj[key];
    });
}

module.exports = dedupeLogs;